module.exports = __webpack_public_path__ + "assets/img/chart.15fe45db.svg";